import GenericDB from './generic-db';

export default class AssessmentTypeFieldsDB extends GenericDB {
  constructor() {
    super('assessmentTypeFields');
  }
}
